<template>
  <div>
    <el-dialog
      :before-close="handleClose"
      title="智能识别"
      :visible.sync="Open"
      width="580px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" label-width="100px" :model="form" :rules="rules">
        <el-form-item label="营业执照" prop="imgArr">
          <div class="flex-y">
            <UploadFile
              type="SUPPLIER_BUSINESS_LICENSE"
              @uploadSuccess="uploadSuccess"
              :multiple="false"
              :btn-text="'上传图片'"
              :file-type="[
                'png',
                'jpg',
                'jpeg',
                'jpe',
                'bmp',
                'gif',
                'tiff',
                'tif',
                'webp',
                'jpe',
                'jpe',
              ]"
            />
            <div class="f12 text-muted">
              支持格式：png / jpg / jpeg / jpe / bmp / gif / tiff / tif / webp
              等，图片大小不超过10M，最长边不超过8192像素！
            </div>
            <div class="mt10 flex-x">
              <div
                class="pos mr10"
                v-for="(item, index) of form.imgArr"
                :key="index"
              >
                <div class="deleteurl" @click="handleRemoveImg(index)">
                  <i class="el-icon-circle-close"></i>
                </div>
                <el-image
                  fit="cover"
                  :preview-src-list="[item.attachmentUrl]"
                  :src="item.attachmentUrl"
                  style="width: 100px; height: 100px"
                />
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="dialogConfirm">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { ocr } from '@/api/common'
  export default {
    components: {},
    props: {
      addressRowInfo: {
        type: Object,
        default: () => {
          return {}
        },
      },
    },
    data() {
      return {
        Open: true,
        form: {
          imgArr: [],
        },
        rules: {
          imgArr: [
            {
              required: true,
              message: '请上传资料',
              trigger: 'change',
            },
          ],
        },
      }
    },
    created() {
      this.form = Object.assign(this.form, this.addressRowInfo)
    },
    mounted() {
      this.resetForm('form')
    },
    methods: {
      uploadSuccess(data) {
        console.log('🚀 ~ uploadSuccess ~ data:', data)
        data.forEach((item) => {
          console.log('🚀 ~ data.forEach ~ item:', item)
          this.form.imgArr.push({
            attachmentName: item.fileName,
            attachmentUrl: item.url,
          })
        })
        this.msgSuccess('操作成功')
        console.log('🚀 ~ uploadSuccess ~ val:', data)
      },
      handleRemoveImg(index) {
        this.$confirm('确定删除？删除后无法恢复', '删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.form.imgArr.splice(index, 1)
          })
          .catch(() => {})
      },
      dialogConfirm() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            if (this.form.imgArr.length == 0) {
              this.msgError('请上传资料')
              return
            }
            if (this.form.imgArr.length > 1) {
              this.msgError('只允许上传一份资料')
              return
            }
            ocr({ url: this.form.imgArr[0].attachmentUrl }).then((res) => {
              this.$emit('getAISee', res.data)
            })
          }
        })
      },
      handleClose() {
        this.$emit('getAISee')
      },
    },
  }
</script>
<style lang="scss" scoped>
  .deleteurl {
    color: #333;
    font-size: 26px;
    position: absolute;
    right: -13px;
    top: -13px;
    z-index: 2;
    cursor: pointer;
  }
</style>
